"use client";

import { Box, Text, Title } from "@mantine/core";
import clsx from "clsx";
import { capAll } from "@/lib/strapi/formatters";
import { Resources } from "@tsTypes/subject-schema";
import { useTopicMeta } from "../../../../../../components/CoreDataProvider";
import { SubjectTableSchema } from "../../layouts/SubjectResourceLayout";
import { SubTopicButton } from "./components/SubTopicButton";
import classes from "./SubjectTable.module.css";

export default function SubjectTable({
  subjectName,
  topicDocumentId,
  topicTitle,
  topicDescription,
  tableMeta,
  resource,
  topicLevel,
  noMarginTop,
}: {
  subjectName: string;
  topicDocumentId: string;
  topicTitle: string;
  topicDescription: string;
  tableMeta: SubjectTableSchema[];
  resource: Resources;
  topicLevel?: boolean;
  noMarginTop?: boolean;
}) {
  const topicMeta = useTopicMeta(topicDocumentId);
  const subjectNameLower = subjectName.toLowerCase();
  return (
    <>
      <Title
        order={2}
        id={topicDocumentId}
        mt={noMarginTop ? "0" : "15vh"}
        className={classes.title}
      >
        Topic {topicMeta.number} - {topicMeta.title}
      </Title>
      <Text className={classes.description}>{`${topicDescription.replaceAll(
        "&nbsp;",
        " "
      )}`}</Text>
      <Box
        className={clsx(
          "progressive-fade-in",
          classes.topicContainer
        )}
      >
        <SubTopicButton
          subTopicDocumentId={topicDocumentId}
          resource={resource}
          subjectNameLower={subjectNameLower}
          topicIndex={topicMeta.index}
          topicTitle={topicTitle}
          topicLevel={topicLevel}
          topicNumber={topicMeta.number}
          subTopicDescription={
            topicLevel
              ? `View the ${resource} for IB ${capAll(subjectNameLower)} topic ${topicMeta.number}.`
              : `View the ${resource} for all ${tableMeta.length} of the IB ${capAll(subjectNameLower)} topic ${topicMeta.number} subtopics combined.`
          }
        />
        {!topicLevel &&
          tableMeta.map((tableItem) => (
            <SubTopicButton
              key={tableItem.subTopicDocumentId}
              {...tableItem}
              resource={resource}
              subjectNameLower={subjectNameLower}
              topicIndex={topicMeta.index}
              topicTitle={topicTitle}
            />
          ))}
      </Box>
    </>
  );
}
